import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient'

export default {
	async [actionTypes.ITENS.BUSCAR_POR_FILTRO]({ state }) {
		const { filtro, paginacao } = state

		const { data } = await api.itens.buscarItensPorFiltro(filtro, paginacao)
		return data
	},
}
